import { Button, Checkbox, DatePicker, Form, message, Select, Space } from "antd";
import dayjs from "dayjs";
import { ReportApiService } from "features/report/api/report-api.services";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";


const { RangePicker } = DatePicker;

export const SideBarFilterView = ({
    data,
    filter,
    setFilter,
    ReportType,
    setReportTypeData,
    setEntryTypeId,
    GranularityId,
    setGranularity,
    dateRange,
    setDateRange,
    setWeightType,
    setMaterialId,
    setIsExcludeInSideVehicle,
    isExcludeInSideVehicle,
    materialId,
    setFilterTable,
    entryTypeId

}: any) => {
    const [form] = Form.useForm();
    const [selectedEntryType, setSelectedEntryType] = useState<any>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const [materialList, setMaterialList] = useState<any>([]);
    const granularity = data?.granularity?.res?.commonList || [];
    const reporttype = data?.reportType?.res?.commonList || [];
    const entryType = data?.entryType?.res?.commonList || [];

    const defaultReportType = ReportType;
    const reportTypeOptions = reporttype.map((item: any) => ({
        label: item.title,
        value: item.id,
    }));
    useEffect(() => {
        if (reportTypeOptions.length > 0 && !filter.ReportTypeId) {
            form.setFieldsValue({ reportType: defaultReportType });
            setFilter((prev: any) => ({ ...prev, ReportTypeId: defaultReportType }));
        }
    }, [reportTypeOptions]);
    useEffect(() => {
        setReportTypeData(ReportType);

        if (!filter.ReportTypeId) return;

        let updatedEntryType = [...entryType];
        let defaultEntry: any = null;

        if (filter.ReportTypeId === 1) {
            // TAT -> add "All"
            if (!updatedEntryType.find((item: any) => item.title === "All")) {
                updatedEntryType = [{ id: null, title: "All" }, ...updatedEntryType];
            }
            defaultEntry = null;
        } else if (filter.ReportTypeId === 2) {
            // Tolerance -> default select "Weight Bridge"
            defaultEntry = 4;
        }

        form.setFieldsValue({ entryType: defaultEntry });
        setEntryTypeId(defaultEntry);
        setSelectedEntryType(defaultEntry);
    }, [filter.ReportTypeId, entryType]);
   

    const onFinish = (values: any) => {
        const payload = {
            StartDate: dateRange[0].format("YYYY-MM-DD"),
            EndDate: dateRange[1].format("YYYY-MM-DD"),
            GarnularityId: values.granularity || GranularityId,
            ReportTypeId: values.reportType || defaultReportType,
            EntryTypeId: values.entryType ?? null,
            WeightType: values.Weight_type ?? null,
            MaterialId: materialId ?? null,
            IsExcludeInSideVehicle: isExcludeInSideVehicle,
            Page: 1,
            Size: 10,
        };
        /* ---------- STATE UPDATES ---------- */
        setGranularity(values.granularity);
        setEntryTypeId(values.entryType);
        setSelectedEntryType(values.entryType);
        if (ReportType === 2) {
            setWeightType(values.Weight_type);
        }
        setFilter(payload);
        setFilterTable(payload);

        /* ---------- URL QUERY PARAMS ---------- */
        const params: any = {
            StartDate: payload.StartDate,
            EndDate: payload.EndDate,
            GarnularityId: payload.GarnularityId,
            ReportTypeId: payload.ReportTypeId,
            EntryTypeId:
                payload.EntryTypeId !== null
                    ? String(payload.EntryTypeId)
                    : undefined,
            WeightType:
                payload.WeightType !== null
                    ? String(payload.WeightType)
                    : undefined,
            MaterialId:
                payload.MaterialId !== null
                    ? String(payload.MaterialId)
                    : undefined,
        };

        // remove empty params from URL
        Object.keys(params).forEach(
            (key) => params[key] === undefined && delete params[key]
        );

        setSearchParams(params);
    };


    const onReset = () => {

        form.resetFields();
        form.setFieldsValue({ date: [], reportType: defaultReportType, granularity: 1, entryType: (ReportType == 2) ? entryTypeId : null });
        setDateRange([dayjs().subtract(1, "month").startOf("month"),   // 1st day of previous month
        dayjs().subtract(1, "month").endOf("month")]);
        setFilter({
            StartDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            EndDate: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
            GarnularityId: 1,
            ReportTypeId: defaultReportType,
            EntryTypeId: (ReportType == 2) ? entryTypeId : null,
            WeightType: null,
            MaterialId: null,
            Page: 1,
            Size: 10
        });

        setFilterTable({
            StartDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            EndDate: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
            GarnularityId: 1,
            ReportTypeId: defaultReportType,
            EntryTypeId: (ReportType == 2) ? entryTypeId : null,
            WeightType: null,
            Page: 1,
            Size: 10
        });


        setGranularity(1);
        if (ReportType == 2) {
            setEntryTypeId(entryTypeId);
        } else {
            setEntryTypeId(null);
            setMaterialId(null);
            setIsExcludeInSideVehicle(null)
        }

        if (ReportType != 2 && entryTypeId != 1) {
            setSelectedEntryType(null);
        }


    };

    const inital = async () => {
        try {
            let flag = "";
            if (ReportType === 4) {
                flag = "LoadMaterialType";
            } else if (ReportType === 5) {
                flag = "UnLoadingMaterialFilter";
            } else {

                return;
            }
            const apires: any = await ReportApiService().getReportCommonList({ Flag: flag } as any);

            setMaterialList(apires?.res || []);
        } catch (error: any) {
            message.error(error?.message || "Failed to fetch material list");
        }
    };
    useEffect(() => {
        inital();
    }, [ReportType]);
useEffect(() => {
  if (!searchParams.toString()) return;

  const startDate = searchParams.get("StartDate");
  const endDate = searchParams.get("EndDate");

  if (!startDate || !endDate) return;

  const payload = {
    StartDate: startDate,
    EndDate: endDate,
    GarnularityId: Number(searchParams.get("GarnularityId")),
    ReportTypeId: Number(searchParams.get("ReportTypeId")),
    EntryTypeId: searchParams.get("EntryTypeId")
      ? Number(searchParams.get("EntryTypeId"))
      : null,
    WeightType: searchParams.get("WeightType")
      ? Number(searchParams.get("WeightType"))
      : null,
    MaterialId: searchParams.get("MaterialId")
      ? Number(searchParams.get("MaterialId"))
      : null,
    Page: 1,
    Size: 10,
  };

  setFilter(payload);
  setFilterTable(payload);

  setDateRange([dayjs(startDate), dayjs(endDate)]);
  form.setFieldsValue({
    granularity: payload.GarnularityId,
    reportType: payload.ReportTypeId,
    entryType: payload.EntryTypeId,
    Weight_type: payload.WeightType,
  });
}, []);
    
return (
        <>
            <h1 className="text-sm font-semibold mb-4">Report Parameter</h1>
            <Form form={form} layout="vertical" initialValues={{ ...filter }} onFinish={onFinish}>
                <label>Date</label>
                <RangePicker
                    value={dateRange}
                    onChange={(dates) => {
                        setDateRange(dates);
                        form.setFieldsValue({ date: dates });
                    }}
                    format="YYYY-MM-DD"
                />

                <Form.Item name="granularity" label="Granularity" style={{ marginTop: 16 }}>
                    <Select
                        placeholder="Please select"
                        defaultValue={"Month"}

                        style={{ width: "100%" }}
                        options={granularity.map((item: any) => ({
                            label: item.title,
                            value: item.id,
                        }))}
                        //  onChange={(value) =>{ setGranularity(value)}}
                        value={GranularityId}
                    />
                </Form.Item>
                {(ReportType !== 4 && ReportType !== 5) ? (
                    <Form.Item name="entryType" label="Entry Type">
                        <Select
                            placeholder="Please select entry type"
                            style={{ width: "100%" }}
                            options={[
                                ...(filter.ReportTypeId === 1 || filter.ReportTypeId === 3 || filter.ReportTypeId === 4
                                    ? [{ label: "All", value: null }]
                                    : []),
                                ...entryType.map((item: any) => ({
                                    label: item.title,
                                    value: item.id,
                                })),
                            ]}
                            onChange={(value) => {
                                setSelectedEntryType(value);
                            }}
                        />
                    </Form.Item>) : null}
                {ReportType === 2 && selectedEntryType === 1 && (
                    <Form.Item
                        label="Weight Type"
                        name="Weight_type"
                        initialValue={0}
                    >
                        <Select
                            placeholder="Select weight type"
                            style={{ width: "100%" }}
                            options={[
                                { label: "All", value: 0 },
                                { label: "OverWeight", value: 1 },
                                { label: "UnderWeight", value: 2 },
                            ]}
                        />
                    </Form.Item>
                )}
                {(ReportType == 4 || ReportType == 5) && (
                    <>
                        <Form.Item
                            name="materialName"
                            label="Material Name"
                            initialValue={null}
                        >
                            <Select
                                placeholder="Select material"
                                options={[
                                    { label: "All", value: null },
                                    ...(materialList?.commonList?.map((item: any) => ({
                                        label: item?.title,
                                        value: item?.id,
                                    })) || []),
                                ]}
                                onChange={(value) => setMaterialId(value)}
                            />
                        </Form.Item>

                        <Form.Item name="IsExcludeInSideVehicle" valuePropName="checked" noStyle>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span>Exclude Inside Vehicle</span>
                                <Checkbox
                                    checked={isExcludeInSideVehicle}
                                    onChange={(e) => setIsExcludeInSideVehicle(e.target.checked)}
                                />
                            </div>
                        </Form.Item>

                        <br />

                    </>
                )}


                <Form.Item className="">
                    <Space>
                        <Button type="primary" htmlType="submit">
                            Apply
                        </Button>
                        <Button onClick={onReset}>Reset</Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
};
